import React, {useRef, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {useUpdateEffect} from 'ahooks';
import useProps from '../use-props';
import Dom from './Dom';

// 将 jsx 的 style 小驼峰的 key 属性，转化为 cssText 的 -
const convertCamelToCSS = (style) => {
    let cssText = '';
    for (let property in style) {
        if (style.hasOwnProperty(property)) {
            let value = style[property];
            if (value && typeof value === 'number' && !isNaN(value)) {
                value = value + 'px';
            }
            let cssProperty = property.replace(/([A-Z])/g, '-$1').toLowerCase();
            cssText += `${cssProperty}: ${value}; `;
        }
    }

    return cssText;
}

export default function (props) {
    const {data, getParentContainer, style, cssText, show = true, children, ...otherProps} = props;
    const {map} = useProps();

    const domRef = useRef(document.createElement('div'));
    const overlay = useRef();

    useEffect(() => {
        setStyle(cssText, style);

        overlay.current = new Dom({
            map,
            position: data,
            element: domRef.current,
            positioning: "bottom-center",
            offset: [0, -10],
            ...otherProps
        });

        const parentDom = getParentContainer ? getParentContainer() : map._element;
        parentDom.appendChild(domRef.current);

        return () => {
            overlay.current.destroy();

            parentDom.removeChild(domRef.current);
        }
    }, []);

    useUpdateEffect(() => {
        setStyle(cssText, style);
    }, [cssText, JSON.stringify(style)]);

    useUpdateEffect(() => {
        overlay.current.setPosition(data)
    }, [JSON.stringify(data)])

    useUpdateEffect(() => {
        domRef.current.style.display = show ? 'block' : 'none';
    }, [show])

    const setStyle = (_cssText, _style) => {
        let cssText = domRef.current?.style?.cssText || `
            display: ${show ? 'block' : 'none'};
            position: absolute;
            user-select: none;
            pointer-events: none;
        `;

        // 兼容css未加;
        if (_cssText) {
            const lastStr = _cssText[_cssText.length - 1];
            if (lastStr !== ';') {
                _cssText = `${_cssText}; `
            }

            cssText = `
                ${cssText}
                ${_cssText}
            `
        }

        if (_style) {
            // 转换为CSS文本
            const styleToCss = convertCamelToCSS(_style);
            cssText = `
                ${cssText}
                ${styleToCss}
            `
        }

        domRef.current.style.cssText = cssText;
    }

    return ReactDOM.createPortal(
        children,
        domRef.current
    );
}

// export default function (props) {
//     const {data, style, show = true, children, ...otherProps} = props;
//     const {map} = useProps();
//
//     const domRef = useRef();
//     const overlay = useRef();
//
//     useEffect(() => {
//         overlay.current = new Dom({
//             map,
//             position: data,
//             element: domRef.current,
//             positioning: "bottom-center",
//             offset: [0, -10],
//             ...otherProps
//         });
//
//         return () => {
//             overlay.current.destroy();
//         }
//     }, []);
//
//     useUpdateEffect(() => {
//         overlay.current.setPosition(data)
//     }, [JSON.stringify(data)])
//
//     return (
//         <div
//             ref={domRef}
//             style={{
//                 display: show ? 'block' : 'none',
//                 position: 'absolute',
//                 userSelect: 'none',
//                 pointerEvents: 'none',
//                 ...style
//             }}
//         >
//             {children}
//         </div>
//     )
// }
